import "./extensions/jquery.oc.extensions.js";
import Commons from "./Commons.js";
import Handlebars from "handlebars";

let pixel_per_mm_x = null;
let pixel_per_mm_y = null;

let globalUiComponentCounter = 0;
window._handlebarsUiComponent = {};

/**
 * Statische Utility-Klasse zum DOM.
 */
export default class Doms {

    /**
     * Ruft callback auf, sobald alle events des eventNames-Arrays auf dem element ausgelöst worden sind.
     */
    static waitUntilAllEventsHappened(element, eventNames, callback) {
        const jElement = $(element);
        const events = new Set(eventNames);
        eventNames.forEach((event)=> {
            jElement.on(event, ()=> {
                events.delete(event);
                if (events.size === 0) {
                    callback();
                }
            });
        });
    }

    /**
     * mouse events often occure too frequently, depending on system and input device. It's best practise to throttle
     * those events at a maximum rate of the browser's framerate in order to prevent performance issues.
     * see http://spoike.ghost.io/user-input-framerate-throttling-in-the-browser/
     * @example
     * element.on('mousemove',Doms.framerateThrottle((event)=>{console.log('mousemove throttled',event);}));
     *
     * @deprecated nicht mehr verwenden, führt zu Performanceproblemen!
     */
    static framerateThrottle(eventCallback) {
        // SBA führt zu Performanceproblemen!!
        return eventCallback;

        // var mayUpdate = false;
        // function update(timestamp) {
        //     mayUpdate = true;
        //     requestAnimationFrame(update);
        // }
        // requestAnimationFrame(update);
        // return function() {
        //     var thisArg = this;
        //     if (mayUpdate) {
        //         mayUpdate = false;
        //         return eventCallback.apply(thisArg, arguments);
        //     }
        // }
    }

    /**
     * ist das Element mit dem Document-DOM verbunden?
     */
    static isElementAttachedToDocument(element) {
        const domElement = Doms.isJQueryObject(element) ? element[0] : element;
        // document.querySelector("oc-viewer") !!!????
        const isAttached = $.contains(document.documentElement, domElement) || document.querySelector("oc-viewer");
        return isAttached;
    }

    /**
     * Ist das object irgend ein JQuery-Object wie z.B. $('body')?
     * Es wird nicht getestet, ob object.length>0, ob also der Selektor matched.
     * Der Test klappt auch, wenn es mehrere JQuery-Instanzen gibt.
     */
    static isJQueryObject(object) {
        return object && (object instanceof $ || object.constructor.prototype.jquery);
    }

    /**
     * gibt das Bild als Base64 - encodetes JPG zurück,
     * wobei die data:image - Einleitung entfernt wird.
     */
    static getAsJpgBase64Encoded(canvasOrImage) {
        const imageData = $(canvasOrImage)[0].toDataURL("image/jpeg");
        return imageData.replace(/^data:image\/(png|jpeg);base64,/, "");
    }

    /**
     * Gibt die Pixel pro MM zurück
     */
    static getPixelPerMM(dimension='x') {
        return dimension=='x' ? Doms.getPixelPerMMForX() : Doms.getPixelPerMMForY();
    }

    /**
     * Gibt die Pixel pro MM zurück
     */
    static getPixelPerMMForX() {
        if (pixel_per_mm_x == null) {
            const div = document.createElement("div");
            div.style.width = "1mm";
            const body = document.getElementsByTagName("body")[0];
            body.appendChild(div);
            const ppm = document.defaultView.getComputedStyle(div, null).getPropertyValue('width');
            body.removeChild(div);
            pixel_per_mm_x = parseFloat(ppm);
        }
        return pixel_per_mm_x;
    }

    /**
     * Gibt die Pixel pro MM zurück
     */
    static getPixelPerMMForY() {
        if (pixel_per_mm_y == null) {
            const div = document.createElement("div");
            div.style.height = "1mm";
            const body = document.getElementsByTagName("body")[0];
            body.appendChild(div);
            const ppm = document.defaultView.getComputedStyle(div, null).getPropertyValue('height');
            body.removeChild(div);
            pixel_per_mm_y = parseFloat(ppm);
        }
        return pixel_per_mm_y;
    }

    /**
     * Konvertiert einen CSS-Wert wie 5em in die Einheit px um.
     * @param {number} value der Zahlenwert
     * @param {?string} unit die Einheit des Zahlenwertes wie em, %, mm usw.
     * @param {string} [dimension='x'] entweder 'x' oder 'y'
     * @return {*}
     */
    static convertUnitToPX(value,unit,containerElement,dimension='x',containerWidth,containerHeight) {
        switch (unit) {
            case 'px': return value;
            case '%': return (dimension=='x'
                    ? (containerWidth==null?$(containerElement).width():containerWidth)
                    : (containerHeight==null?$(containerElement).height():containerHeight)) / 100 * value;
            case 'em': return parseFloat(getComputedStyle($(containerElement)[0]).fontSize) * value;
            case 'mm': return Doms.getPixelPerMM(dimension) * value;
            case 'cm': return Doms.getPixelPerMM(dimension) * 10 * value;
            case 'in': return Doms.getPixelPerMM(dimension) * 25.4 * value;
            case 'pt': return Doms.getPixelPerMM(dimension) * 1/72 * 25.4 * value;
            case 'pc': return Doms.getPixelPerMM(dimension) * 1/6 * 25.4 * value;
            case 'rem': return parseFloat(getComputedStyle(document.body).fontSize) * value;
            case 'vw': return document.documentElement.clientWidth / 100 * value;
            case 'vh': return document.documentElement.clientHeight / 100 * value;
            case 'vmin': return Math.min(document.documentElement.clientWidth,document.documentElement.clientHeight) / 100 * value;
            case 'vmax': return Math.max(document.documentElement.clientWidth,document.documentElement.clientHeight) / 100 * value;
        }
        return value;
    }

    /**
     * Kompiliert ein Handlebars-Template. Man kann entweder einen JQuery-Selektor übergeben
     * oder direkt den String des Templates.
     */
    static template(tmpl) {
        if (Doms.isJQueryObject(tmpl)) {
            if (tmpl.length == 0) {
                console.warn('no ' + tmpl.selector);
                return ()=>'no ' + tmpl.selector;
            }
            tmpl = tmpl.html();
        }
        return Handlebars.compile(tmpl);
    }

    /**
     * Registriert alle Methoden eines Objektes als Handlebars-Helper, wobei spätere Laufzeitfehler bei Aufrufen dieser Methoden sicher abgefangen und als Text / consolenmeldung ausgegeben werden.
     */
    static handlebarsRegisterSafe(handlebar_extensions) {

        function safe(fn) {
            return function() {
                try {
                    return fn.apply(this, arguments);
                } catch (e) {
                    console.warn(e);
                    return "[ERROR: " + e + "]";
                }
            }
        }

        for ( var helper in handlebar_extensions) {
            Handlebars.registerHelper(helper, safe(handlebar_extensions[helper]));
        }
    }

    /**
     * registriert eine (möglicherweise aktive) UI-Komponente als Handlebars-Helper. Im Unterschied zu
     * normalen Handlebars-Helpern kann eine UI-Komponente Jquery-Elemente oder DOM-Elemente zurückgeben.
     * Diese können dann Listener auf z.B. Buttons registriert haben.
     * @param name Name des Handlebars-Helpers
     * @param helperFunction die erzeugende UI-Funktion
     * @example
     * Doms.registerHandlebarsUiComponent('HelloWorld',function(color) {
     *    const div = $('<div style="color: '+color+';">Hello World</div>');
     *    div.on('tap',()=>alert('Hello World!!'));
     *    return div;
     * });
     */
    static handlebarsComponent(name,helperFunction) {
        const helper = {};
        helper[name] = function() {
            globalUiComponentCounter++;
            const uiComponentId = '_'+globalUiComponentCounter;
            const result = helperFunction.apply(null,arguments);
            window._handlebarsUiComponent[uiComponentId] = $(result);
            const placeholder = '<script id="HandlebarsUiComponent'+uiComponentId+'">$("#HandlebarsUiComponent'+uiComponentId+'").replaceWith(window._handlebarsUiComponent["'+uiComponentId+'"]);delete window._handlebarsUiComponent["'+uiComponentId+'"];</script>';
            return new Handlebars.SafeString(placeholder);
        }
        Doms.handlebarsRegisterSafe(helper);
    }

    /**
     * Registriert mehrere UI-Componenten auf einmal, die in einem Literal-Objekt definiert sind.
     */
    static handlebarsComponents(helperLiteral) {
        for ( var helper in helperLiteral) {
            Doms.handlebarsComponent(helper, helperLiteral[helper]);
        }
    }

    /**
     *  Erlaubt programmatisches Erstellen von div-Tags mit minimaler JS-Syntax,
     *  inspiriert von Mithril.
     *
     *  @example
     *  var element = Doms.div('#MeineId')
     *  var element = Doms.div('.meineKlasse1.meineKlasse2')
     *
     *  //Kind-Elemente hinzufügen
     *  var element = Doms.div('#MeineId',element1,element2,element3)
     *
     *  //arrays werden flachgeklopft
     *  var element = Doms.div('#MeineId',[element1,element2,[element3]])
     *
     *  //css style setzen:
     *  var element = Doms.div({css: {backgroundColor: 'black'}})
     *
     *  //attribut setzen:
     *  var element = Doms.div({style: "background-color: black;"})
     *
     *  // callback-Methode, mit der man Zugriff auf das Div-Element kriegt (hä??? -> naja,
     *  // falls man Doms.div schachtelt, und ganz innen drin noch was mit dem div machen möchte)
     *  var element = Doms.div('#MeineId',(div)=>{ console.log('hier das div über ein callback',div); })
     */
    static div(...children) {
        var args = ['div'];
        Commons.addAll(args, children);
        return Doms.tag.apply(null, args);
    }

    /**
     *  Erlaubt programmatisches Erstellen von beliebigen-Tags mit minimaler JS-Syntax,
     *  inspiriert von Mithril, analog zu div
     */
    static tag(tag, ...children) {
        tag = $('<' + tag + '>');

        if (children.length > 0 && _.isString(children[0])) {
            var classOrId = children[0];
            children = children.splice(1);
            var clazz = '';
            var array = classOrId.split(/([\.#])/);
            var isId = false;
            array.forEach(s=> {
                if (s == '') {
                    return;
                }
                if (s == '#') {
                    isId = true;
                    return;
                }
                if (s == '.') {
                    isId = false;
                    return;
                }
                if (isId) {
                    tag.attr('id', s);
                    isId = false;
                } else {
                    if (clazz == '') {
                        clazz = s;
                    } else {
                        clazz += ' ' + s;
                    }
                }
            });
            if (clazz != '') {
                tag.attr('class', clazz);
            }
        }
        _.flattenDeep(children).forEach(e=> {
            if (_.isString(e) || _.isElement(e) || Doms.isJQueryObject(e)) {
                tag.append(e)
            } else if (_.isFunction(e)) {
                e(tag);
            } else {
                _.keys(e).forEach(key=> {
                    if (key == 'css') {
                        tag.css(e[key]);
                    } else {
                        tag.attr(key, e[key]);
                    }
                });
            }
        });

        tag.getMe = (callback) => {
            callback(tag);
            return tag;
        }

        return tag;
    }

    /**
     * ruft callback auf, wenn sich die Größe von element ändert, sowie initial einmal,
     * sobald element zum Dom hinzugefügt ist
     */
    static onResize(element,callback) {
        Doms.onAttachToDom(element,()=>{
            if (element._resizeInterval!=null) {
                throw new Error('only one onResize Listener is allowed per Element');
            }
            callback();
            let oldWidth = element.width();
            let oldHeight = element.height();
            element._resizeInterval = setInterval(()=>{
                if (!Doms.isElementAttachedToDocument(element)) {
                    clearInterval(element._resizeInterval);
                    delete element._resizeInterval;
                    return;
                }
                const width = element.width();
                const height = element.height();
                if (oldWidth!=width || oldHeight != height) {
                    oldWidth = width;
                    oldHeight = height;
                    callback();
                }
            },1000);
        });
    }

    /**
     * unbinded das resize event
     */
    static offResize(element) {
        if (element._resizeInterval!=null) {
            clearInterval(element._resizeInterval);
            delete element._resizeInterval;
        }
    }

    /**
     * ruft callback auf, sobald element zum Dom hinzugefügt ist.
     * (Info: Mit element.on('removedFromDom',...) kriegt man das Entfernen eines Elementes mit.)
     */
    static onAttachToDom(element,callback) {
        Commons.delayUntil(callback,()=>Doms.isElementAttachedToDocument(element),60000,100);
    }

    /**
     * gibt die ID oder tag + Klasse in Form eines CSS-Selektors zurück
     * @param element
     */
    static debugName(element) {
        const id = element.attr('id');
        if (id) {
            return '#'+id;
        }
        const tagName = element.prop('tagName').toLowerCase();
        const classNames = element.attr('class').split(' ').filter(x=>!Commons.isEmpty(x)).join('.');
        return tagName + (classNames.length>0 ? '.'+classNames : '');
    }


    /**
     * Berechnet die width in pixel zu einem Element als Kontext (für die Font-Ermittlung) und einem Text.
     * @param element
     * @param text
     * @return {number}
     */
    static measureTextWidth(element, text) {
        return Doms.measureTextMetrics(element,text).width;
    }

    /**
     * Berechnet die TextMetrics zu einem Element als Kontext (für die Font-Ermittlung) und einem Text.
     * @param element
     * @param text
     * @return {TextMetrics}
     */
    static measureTextMetrics(element, text) {
        const domElement = $(element)[0];
        let context = domElement.___measureTextContext;
        if (context==null) {
            const canvas = document.createElement('canvas');
            context = domElement.___measureTextContext = canvas.getContext("2d");
            context.font = getComputedStyle(domElement).font;
        }
        return context.measureText(text);
    }

    /**
     * (pure DOM, nicht JQuery!)
     * entfernt ein Element aus dem Dom
     * @param element
     */
    static removeElement(element) {
        if (element?.parentNode) {
            element.parentNode.removeChild(element);
        }
    }

    /**
     * (pure DOM, nicht JQuery!)
     * setzt eine Class, falls bool true, falls false entfernt sie
     * @param element
     * @param className
     * @param bool
     */
    static setClassIf(element,className,bool) {
        if (element==null) {
            return;
        }
        if (bool) {
            element.classList.add(className);
        } else {
            element.classList.remove(className);
        }
    }

    /**
     * (pure DOM, nicht JQuery!)
     * toggled eine class
     * @param element
     * @param className
     */
    static toggleClass(element,className) {
        const has = element.classList.contains(className);
        Doms.setClassIf(element,className,!has);
    }

    /**
     * (pure DOM, nicht JQuery!)
     * ermittelt zu einer css-variablen den Wert
     * @param value
     * @returns {string}
     */
    static getCssVar(cssVariableName,root= document.documentElement) {
        return getComputedStyle(root)
            .getPropertyValue(cssVariableName)
            .replace(/\s/g, "");
    }

    /**
     * (pure DOM, nicht JQuery!)
     * ermittelt, ob ein Element in einem container sichtbar ist oder aus dem Bereich herausgescrolled ist
     * @param element
     * @param container
     * @returns {boolean}
     */
    static isScrolledIntoView(element, container, x=true, y=true) {
        const a = element.getBoundingClientRect();
        const b = container.getBoundingClientRect();
        return (!y || (a.top >= b.top && a.bottom <= b.bottom))
            && (!x || (a.left >= b.left && a.right <= b.right));
    }

    /**
     * (pure DOM, nicht JQuery!)
     * ruft scrollIntoView nur dann auf, wenn das Element ausserhalb des sichtbaren Bereiches liegt
     * @param element
     * @param options
     */
    static scrollIntoViewIfNeeded(element, container, options=undefined, x=true, y=true) {
        if (element==null || Doms.isScrolledIntoView(element,container,x,y)) {
            return;
        }
        element.scrollIntoView(options);
    }

}
